<template>
	<div class="container-box">
		<div class="container">
			<navigations :path="path"></navigations>
			<div class="container-center">
				<div class="container-phone">
					<img class="container-phone-img" src="../assets/phone.png" alt="">
				</div>
				<div class="container-text">
					<div class="container-bottom">
						<div class="container-explain">
							<div class="container-happy">
								<img class="container-happy-img" src="../assets/happy.png" alt="">
							</div>
							<div class="container-context">
								<span class="container-context-text">
									在时购圈 APP，你可以随时随地的结识新的朋友
								</span>
								<span class="container-context-text">
									通过有趣的线上匹配机制，随时随地线下欢聚，还可以在线团购美食、娱乐休闲、生活服务等
								</span>
								<span class="container-context-text">
									享受一站式便捷消费的同时更能收获真挚友谊。
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container-center-phone">
				<div class="container-img-top">
					<img class="container-img-top-img" src="../assets/back-4.png" alt="">
				</div>
				<div class="container-phone">
					<img class="container-phone-img" src="../assets/phone.png" alt="">
				</div>
				<div class="container-text">
					<div class="container-bottom">
						<div class="container-explain">
							<div class="container-happy">
								<img class="container-happy-img" src="../assets/happy-phone.png" alt="">
							</div>
							<div class="container-context">
								<span class="container-context-text">
									在时购圈 APP，你可以随时随地的结识新的朋友
								</span>
								<span class="container-context-text">
									通过有趣的线上匹配机制，随时随地线下欢聚，还可以在线团购美食、娱乐休闲、生活服务等
								</span>
								<span class="container-context-text">
									享受一站式便捷消费的同时更能收获真挚友谊。
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabbar></tabbar>
	</div>
	
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				path: '/index'
			};
		},
		mounted() {
			let isMobile = window.innerWidth <= 768;
			if(isMobile){
				this.$router.push("/indexH5")
			}
		},
		methods: {}
	}
</script>

<style>
	html,
	body {
		height: 100%;
		margin: 0;
	}
	
	.container-box{
		width: 100%;
		height: 100%;
	}
	
	.container {
		width: 100%;
		height: 100%;
		background: url("../assets/back-4.png");
		background-position: center;
		background-repeat: no-repeat;
		background-attachment: fixed;
		display: flex;
		align-items: center;
	}

	.container-center {
		width: 100%;
		height: 600px;
		padding: 0 15%;
		position: relative;
		margin-top: 10%;
		box-sizing: border-box;
	}

	.container-center-phone {
		display: none;
	}

	.container-phone {
		position: absolute;
		top: 0;
		height: 100%;
		width: 300px;
		z-index: 5;
	}

	.container-phone-img {
		width: 100%;
	}

	.container-text {
		position: absolute;
		top: 0;
		left: 15%;
		height: 100%;
		width: 70%;
		z-index: 4;
		display: flex;
		align-items: flex-end;
	}

	.container-bottom {
		width: 100%;
		height: 300px;
		margin-bottom: 30px;
		border-radius: 50px;
		backdrop-filter: blur(20px);
		display: flex;
		justify-content: flex-end;
	}

	.container-explain {
		height: 100%;
		width: 75%;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-items: flex-start;
	}

	.container-happy {
		height: 50%;
		display: flex;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.container-happy-img {
		height: 90%;
	}

	.container-context {
		height: 50%;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
	}

	.container-context-text {
		font-size: 22px;
		color: #fff;
		text-align: left;
		margin-top: 5px;
		text-shadow: 0px 5px 10px #999;
		letter-spacing: 2px;
	}

	@media screen and (max-width: 768px) {
		.container {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			background-color: #fff;
			background-image: none;
		}

		.container-img-top {
			width: 100%;
			margin-top: 325px;
		}

		.container-img-top-img {
			width: 100%;
		}

		.container-center {
			display: none;
		}

		.container-center-phone {
			display: flex;
			padding: 0;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
		}

		.container-phone {
			height: auto;
			position: inherit;
			margin-top: 15px;
		}

		.container-phone-img {
			width: 60%;
		}

		.container-text {
			position: inherit;
			left: 0;
			height: auto;
			width: 100%;
			margin-top: 0px;
		}

		.container-context-text {
			font-size: 13px;
			color: #A6A6A6;
			text-align: center;
			text-shadow: 0px 1px 5px #999;
		}

		.container-happy {
			width: 100%;

		}

		.container-happy-img {
			width: 100%;
			height: auto;
		}

		.container-explain {
			width: 100%;
			box-sizing: border-box;
			padding: 15px 55px;
		}

		.container-bottom {
			backdrop-filter: blur(0);
			padding: 15px;
		}

	}
</style>